<template>
  <v-container fluid class="mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
                    <v-btn color="default" class="button-shadow mb-2 mr-0 mr-sm-2" v-on:click="PrintElement('print-page')">
                      <v-icon class="mr-2">mdi-printer</v-icon>
                      Print
                    </v-btn>
                    <v-btn color="success" class="button-shadow" @click="Done">
                      <v-icon class="mr-2">mdi-check</v-icon>
                      Done
                    </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12" id="print-page">
        <v-row class="print-page">
          <v-col cols="12" md="8" sm="12">
            <v-card class="ma-1">
              <v-card-text class="printBody">
                <v-row>&nbsp;</v-row>
                <v-row justify="space-between">
                  <table style="width: 100%; margin-right: 10px; margin-left: 10px;">
                    <tr>
                      <td style="width:40%"><img :src="logo" height="80"  alt="Logo" /></td>
                      <td></td>
                      <td style="width: 35%; text-align: right; vertical-align: text-top">
                         <table style="width: 100%">
                          <tr>
                            <td><span style="font-size: 11pt; font-weight: bold">Request Num</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt;">{{ initvalue.requestnum }}</span></td>
                          </tr>
                          <tr>
                            <td><span style="font-size: 11pt; font-weight: bold">Date</span></td>
                            <td style="text-align: right"><span style="font-size: 11pt; text-alignment: right;">{{ new Date(initvalue.requestdate).toLocaleString('EN-SG',{ year: 'numeric', month: 'numeric', day: 'numeric' })  }}</span></td>
                          </tr>
                         </table> 

                      </td>
                    </tr>
                    <tr>
                      <td colspan="3"><div align="center"><h4 class="ma-0">{{ initvalue.requesttype }}</h4></div></td>
                    </tr>
                  </table>
                </v-row>
                <v-row class="mb-5 greyBold--text" cols="12">
                  <v-col cols="12">
                  
                  </v-col>
                </v-row>
                <v-row class="mb-5 greyBold--text">
                  <table style="width: 100%; margin-right: 10px; margin-left: 10px;" cellpadding="0" cellspacing="0">
                    <tr>
                      <td style="width: 35%; vertical-align: text-top">
                        <div>
                          <span style="font-size: 11pt; font-weight: bold">Employee</span>
                          <p style="margin-top: 0;margin-bottom: 0;">{{ initvalue.requestname }}</p>
                          <p style="margin-top: 0;margin-bottom: 0; white-space: pre;">{{ initvalue.requestaddress }}</p>
                          <p style="margin-top: 0;margin-bottom: 0;">{{ initvalue.requestphone }}</p>
                          <p style="margin-top: 0;margin-bottom: 0;">{{ initvalue.requestmobile }}</p>
                        </div>
                      </td>
                      <td>&nbsp;&nbsp;</td>
                      <td style="width: 45%; text-align: right; vertical-align: text-top">

                      </td>
                    </tr>
                  </table>
                  <div>&nbsp;&nbsp;</div>
                </v-row>
                <table v-if="initvalue.requesttype=='Benefit Request'" style="width: 100%" cellpadding="0" cellspacing="0">
                    <thead>
                    <tr>
                      <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid">#</th>
                      <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid">Account</th>
                      <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid">Description</th>
                      <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid"></th>
                      <th style="text-align: right; border-bottom: 1px; border-bottom-style: solid">Amount</th>
                    </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(trans, index) in initvalue.transactions"  v-bind:key="trans._id">
                          <td>{{ index + 1 }}</td>
                          <td>{{ accounts.length>0 ? accounts.find(account=>account._id==trans.accountid)['accountname'] : '' }}</td>
                          <td>{{ trans.transdesc }}</td>
                          <td width="100px">&nbsp;</td>
                          <td style="text-align: right">{{ trans.transamount.toFixed(2) }}</td>
                        </tr>
                        <tr><td colspan="5" style="border-bottom: 1px; border-bottom-style: solid">&nbsp;</td></tr>
                        <tr>
                          <td colspan="3" style="vertical-align: text-top; "><strong>Note: </strong>{{ initvalue.requestnote }}</td>
                          <td colspan="1"><span style="font-size: 11pt; font-weight: bold">Total: </span></td>
                          <td style="text-align: right"><span style="font-size: 11pt;">{{ initvalue.requesttotal.toFixed(2) }}</span></td>
                        </tr>
                        <tr><td colspan="5">&nbsp;</td></tr>
                        <tr style="margin-top: 10; margin-bottom: 10;">
                          <td colspan="5">
                            <p style="margin-top: 0;margin-bottom: 0;"><strong>Attachments:</strong></p>
                            <p v-for="(file) in initvalue.files" v-bind:key="file._id" style="margin-top: 0;margin-bottom: 0;">
                              <a :href="file.fileurl" download>{{ file.filename }}</a>
                            </p>
                          </td>
                        </tr>
                    </tbody>
                </table>
                <table v-if="initvalue.requesttype=='Leave Request' || initvalue.requesttype=='Flexible Work Request'" style="width: 100%" cellpadding="0" cellspacing="0">
                    <thead>
                    <tr>
                      <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid">#</th>
                      <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid">Account</th>
                      <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid">Start Date</th>
                      <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid">End Date</th>
                      <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid">Amount</th>
                      <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid">Description</th>
                      <th style="text-align: left; border-bottom: 1px; border-bottom-style: solid"></th>
                    </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(trans, index) in initvalue.transactions"  v-bind:key="trans._id">
                          <td>{{ index + 1 }}</td>
                          <td>{{ accounts.length>0 ? accounts.find(account=>account._id==trans.accountid)['accountname'] : '' }}</td>
                          <td>{{ new Date(trans.transstartdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}</td>
                          <td>{{ new Date(trans.transenddate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}</td>
                          <td>{{ trans.transdays.toFixed(1) }} {{ trans.transinfo!=null ? '(' + trans.transinfo + ')' : '' }}</td>
                          <td>{{ trans.transdesc }}</td>
                          <td width="100px">&nbsp;</td>
                        </tr>
                        <tr><td colspan="7" style="border-bottom: 1px; border-bottom-style: solid">&nbsp;</td></tr>
                        <tr>
                          <td colspan="3" style="vertical-align: text-top; "><strong>Note: </strong>{{ initvalue.requestnote }}</td>
                          <td colspan="1"><span style="font-size: 11pt; font-weight: bold">Total: </span></td>
                          <td><span style="font-size: 11pt;">{{ initvalue.requestdays.toFixed(1) }} days</span></td>
                          <td>&nbsp;</td>
                          <td>&nbsp;</td>
                        </tr>
                        <tr><td colspan="5">&nbsp;</td></tr>
                        <tr style="margin-top: 10; margin-bottom: 10;">
                          <td colspan="5">
                            <p style="margin-top: 0;margin-bottom: 0;"><strong>Attachments:</strong></p>
                            <p v-for="(file) in initvalue.files" v-bind:key="file._id" style="margin-top: 0;margin-bottom: 0;">
                              <a :href="file.fileurl" download>{{ file.filename }}</a>
                            </p>
                          </td>
                        </tr>
                    </tbody>
                </table>
                <p style="margin-top: 0; margin-bottom: 70px">&nbsp;</p>
                <table style="width: 50%" cellpadding="0" cellspacing="0">
                <tr><td style="text-align: right; border-bottom: 2px; border-bottom-style: solid"></td><td></td></tr>
                </table>
                <p style="margin-top: 0; margin-bottom: 0">&nbsp;</p>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
    import {mapActions, mapState} from "vuex";
    export default {
        name: 'PrintPage',
        data(){
          return {
            initvalue: {},
            logo: null,
          };
        },
        methods: {
          ...mapActions('Employee', ['getEmployeesRequest']),
          ...mapActions('Account', ['getAccountsRequest']),
          Done(){
            if(this.initvalue.isFromMyRequest==true) this.$router.push({ name: 'MyRequestList' });
            else this.$router.push({ name: 'RequestList' });
          },
          PrintElement(divid) {
            var content = document.getElementById(divid).innerHTML;
            var mywindow = window.open('', 'Print', 'height=800,width=1000,menubar=0,location=0,status=0,titlebar=0,toolbar=0');

            mywindow.document.write('<html><head><title>Print</title>');
            mywindow.document.write('</head><body onclick="window.print();">');
            mywindow.document.write(content);
            mywindow.document.write('</body></html>');

            mywindow.document.close();
            mywindow.focus()
            mywindow.print();
            return;
          }
        },
        computed: {
          ...mapState('Account', ['accounts']),
          ...mapState('Employee', ['employees']),
        },
        created () {
          this.initvalue = this.$route.params;
          if(!this.initvalue._id) this.$router.push({ name: 'RequestList' });
          if(this.accounts.length==0) this.getAccountsRequest();
          if(this.initvalue.companyid=='60a8acb67418a3429476cd42'){
            this.logo = 'https://tradexc-storage.s3.ap-southeast-1.amazonaws.com/temp/lhs-logo.png';
          }
          else if(this.initvalue.companyid=='60b07f300d820029acae4734'){
            this.logo = 'https://tradexc-storage.s3.ap-southeast-1.amazonaws.com/temp/alh-logo.png';
          }
          else if(this.initvalue.companyid=='60ab15046ef2b65b292b215d'){
            this.logo = 'https://tradexc-storage.s3.ap-southeast-1.amazonaws.com/temp/lhls-logo.png';
          }   
          else if(this.initvalue.companyid=='62b4331045dc085e6430d3ce'){
            this.logo = 'https://tradexc-storage.s3.ap-southeast-1.amazonaws.com/temp/alp-logo.png';
          }   
        },
    };
</script>

<style src="./Print.scss" lang="scss" scoped />
